import React, { useState, useEffect } from 'react';
import logo from '../logo.png';

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulation du chargement avec une barre de progression
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          // Délai supplémentaire pour l'animation de sortie
          setTimeout(() => {
            setIsLoading(false);
          }, 800);
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 100);

    // Temps minimum de chargement de 2.5 secondes
    const minLoadTime = setTimeout(() => {
      setProgress(100);
    }, 2500);

    return () => {
      clearInterval(interval);
      clearTimeout(minLoadTime);
    };
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex items-center justify-center">
      <div className="text-center px-6">
        {/* ASHUD Logo */}
        <div className="mb-8">
          <div className="w-20 h-20 sm:w-24 sm:h-24 mx-auto mb-4">
            <img
              src={logo}
              alt="ASHUD Tchad Logo"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Texte de chargement */}
        <div className="mb-8">
          <h1 className="text-xl sm:text-2xl font-bold text-ink mb-2">
            ASHUD TCHAD
          </h1>
          <p className="text-muted text-sm sm:text-base mb-1">
            Action pour la Solidarité Humanitaire et le Développement
          </p>
          <p className="text-primary text-sm font-medium">
            Solidarité - Performance - Essor
          </p>
        </div>

        {/* Barre de progression */}
        <div className="w-56 sm:w-72 mx-auto">
          <div className="bg-surface border border-line rounded h-1.5 overflow-hidden">
            <div
              className="bg-primary h-full transition-all duration-200 rounded"
              style={{ width: `${Math.min(progress, 100)}%` }}
            ></div>
          </div>
          <p className="text-muted text-xs text-center mt-3 font-medium tabular-nums">
            {Math.round(Math.min(progress, 100))}%
          </p>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
